import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

const ConcreteQualityBadge = ({ normative }) => (
  <span className={styles.badge}>{normative === 'ehe' ? 'DOR' : 'DCOR'}</span>
);

ConcreteQualityBadge.propTypes = {
  normative: PropTypes.string.isRequired,
};

export default ConcreteQualityBadge;
